import { Graphics } from 'pixi.js';
import { Select } from '@pixi/ui';
import { container } from 'tsyringe';
import Button from '../../core/view/ui/Button';
import LayoutElement from '../../core/view/model/LayoutElement';
import SlotMachine from '../../slots/model/SlotMachine';
import AssetsManager from '../../core/assets/AssetsManager';
import { UpdateLayoutDescription } from '../../core/view/UpdateLayoutDescription';
import { ScreenOrientation } from '../../core/view/ScreenOrientation';
import ControlEvent from '../../core/control/event/ControlEvent';
import SoundManager from '../../core/sound/SoundManager';
import { UIPanelEvent } from '../control/event/UIPanelEvent';
import { PopupData, PopupType } from '../model/PopupState';
import SoundList from '../sound/SoundList';
import { BUY_FEATUE_MAX_WIN, MAX_WIN } from '../../../jewels-of-wizard/services/GameConstant';

export default class ForcingButton extends Button {
    private readonly sm: SlotMachine;
    private readonly select: Select;
    private readonly forcingKeys: string[];

    constructor(le: LayoutElement) {
        super(le);

        this.name = 'ForcingButton';
        this.sm = container.resolve(SlotMachine);

        this.forcingKeys = [null, ...this.sm.forcingArray];

        this.select = this.createSelect();
        this.select.onSelect.connect(this.onSelect.bind(this));

        this.addChild(this.select);
    }

    private createSelect(): Select {
        const labels = this.forcingKeys.map(key => {
            if (key === null) {
                return AssetsManager.translations.get('forcing.none');
            }
            else if (key === BUY_FEATUE_MAX_WIN) {
                return AssetsManager.translations.get('forcing.buyFeatureMaxWin');
            }
            else if (key === MAX_WIN) {
                return AssetsManager.translations.get('forcing.maxWin')
            }

            return key;
        }
        );

        const select = new Select({
            closedBG: this.createOpenBG(),
            openBG: this.createOpenBG(),

            textStyle: {
                fill: 0xf2ff00,
                fontSize: 20,
                fontWeight: '700',
                dropShadow: true,
                dropShadowColor: 0x000000,
                dropShadowBlur: 6,
                dropShadowDistance: 2,
            },

            items: {
                items: labels,
                width: 210,
                height: 40,
                backgroundColor: 0x211040,
                hoverColor: 0x5e2fa3,
                textStyle: {
                    fill: 0xFFFFFF,
                    fontSize: 20,
                    fontWeight: '600',
                },

            },

            scrollBox: {
                width: 210,
                height: 3 * 40,
                radius: 4,
            },
        });

        select.y = 10
        select.value = -1; // nothing selected
        return select;
    }

    private onSelect(index: number): void {
        const key = this.forcingKeys[index];

        if (key === null) {
            this.clearForcing();
            return;
        }

        this.sm.forcing = true;
        this.sm.selectedOption = key;
        if (this.sm.selectedOption === BUY_FEATUE_MAX_WIN) {
            const data: PopupData = {
                type: PopupType.FEATURE_BUY,
                hideOnClick: false,
                duration: -1,
                callbacks: null
            }
            SoundManager.play(SoundList.UI_BUTTON_CLICK);
            new ControlEvent(UIPanelEvent.SHOW_POPUP, data).dispatch();
        }
    }

    private clearForcing(): void {
        this.sm.forcing = false;
        this.sm.selectedOption = null;
        this.select.value = -1;
    }

    private createOpenBG(): Graphics {
        const g = new Graphics();

        g.beginFill(0x2b144f);
        g.drawRoundedRect(0, 0, 210, 42, 14);
        g.endFill();

        g.lineStyle(2, 0xf6c453);
        g.drawRoundedRect(0, 0, 210, 42, 14);

        return g;
    }

    public updateLayout(desc: UpdateLayoutDescription) {
        if(desc.orientation === ScreenOrientation.VERTICAL){
            this.select.scale.set(1.5)
        }else{
            this.select.scale.set(1)
        }
    }

    public disableSelect(): void {
        this.select.interactive = false;
        this.select.eventMode = 'none';
        this.select.alpha = 0.5;
    }

    public enableSelect(): void {
        this.select.interactive = true;
        this.select.eventMode = 'static';
        this.select.alpha = 1;
    }
}
